<template>
  <ContentRenderer
      v-if="page"
      :value="page"
      tag="main"
      class="mx-auto"
  />
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'default'
})
const route = useRoute()

const { data: page } = await useAsyncData(route.path, () => {
  return queryCollection('imprints').path(route.path).first()
})

if (!page.value) {
  throw createError({ statusCode: 404, statusMessage: 'Page not found', fatal: true })
}
</script>